import * as realServices from "./realServices";
import * as mockServices from "./mockServices";

const servicesImplementation = process.env.VUE_APP_USE_MOCK_SERVICES === "true" ? mockServices : realServices;

const estateAdService = servicesImplementation.estateAdService;
const scraperService = servicesImplementation.scraperService;
const publisherBlacklistService = servicesImplementation.publisherBlacklistService;
const crawlerSourceService = servicesImplementation.crawlerSourceService;

export { estateAdService, scraperService, publisherBlacklistService, crawlerSourceService };
